"use client";

import { useState } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { httpBatchLink, loggerLink } from "@trpc/client";
import { RouteChangesProvider } from "nextjs-router-events";
import superjson from "superjson";
import { SessionProvider } from "@atalan/auth/react";
import { Toaster } from "@/components/ui/Toast/toaster";
import { TooltipProvider } from "@/components/ui/Tooltip/Tooltip";
import UserContext from "@/components/UserContext/UserContext";
import { GlobalFilterProvider } from "@/contexts/GlobalFilterContext";
import { MessageCenterProvider } from "@/contexts/MessageCenterContext";
import { api } from "@/lib/api";
import { env } from "@/lib/env";
const getBaseUrl = () => {
  if (typeof window !== "undefined") return ""; // browser should use relative url
  if (env.WEB_URL) return env.WEB_URL; // SSR should use web url

  return "http://localhost:3000"; // dev SSR should use localhost
};
export function TRPCReactProvider(props: {
  children: React.ReactNode;
  headers?: Headers;
}) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 1000,
        retry: false
      }
    }
  }));
  const [trpcClient] = useState(() => api.createClient({
    transformer: superjson,
    links: [httpBatchLink({
      // TODO: !Change for web URL
      url: `${getBaseUrl()}/api/trpc`
    }), loggerLink({
      enabled: opts => process.env.NODE_ENV === "development" || opts.direction === "down" && opts.result instanceof Error
    })]
  }));
  return <SessionProvider>
      <api.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <UserContext>
            <RouteChangesProvider>
              <TooltipProvider>
                <GlobalFilterProvider>
                  <MessageCenterProvider>
                    <NiceModal.Provider>{props.children}</NiceModal.Provider>
                    <ReactQueryDevtools initialIsOpen={false} />
                  </MessageCenterProvider>
                </GlobalFilterProvider>
              </TooltipProvider>
            </RouteChangesProvider>
          </UserContext>
        </QueryClientProvider>
      </api.Provider>
      <Toaster />
    </SessionProvider>;
}